import { Storage } from '@24i/nxg-sdk-quantum';

export const getStorageItem = async (key: string) => Storage.getItem(key);
export const setStorageItem = async (key: string, value: string) => Storage.setItem(key, value);
export const removeStorageItem = async (key: string) => Storage.removeItem(key);
